import { deserialize, deserializeAs } from "cerialize";


export class ROrgAccess {
    @deserialize
    idpRoleName: string;
    @deserialize
    accountId: number;
    @deserialize
    userId: number;
}

export class RMemberAccount {
    @deserialize
    accountNodeId: number;
    @deserialize
    parentId: number;
    @deserialize
    accountId: number;
    @deserialize
    accountDescription: string;
    @deserialize
    accountName: string;
}

export class ROrgUnit {
    @deserialize
    ouNodeId: number;
    @deserialize
    parentId: number;
    @deserialize
    ouName: string;
    @deserialize
    ouDescription: string;
}

export class RNode {
    @deserialize
    nodeId: number;
    @deserialize
    parentId: number;
    @deserialize
    name: string;
    @deserialize
    description: string;
    @deserialize
    type: number;
    @deserialize
    hasMembers: boolean;
    @deserialize
    level: number;
    @deserialize
    isSelectable: boolean;

    // for ui
    get email(): string {
        // attempt to split the description by `forward` slash
        // description comes in as `123456/email_user`
        const split = this.description.split('/');

        return split.length === 1 ? split[0] : split[1];
    }

    show: boolean = true;
    selected: boolean = false;
}

export class ROrganization {
    @deserialize
    orgId: number;
    @deserialize
    orgName: string;
    @deserialize
    orgDescription: string;
    @deserialize
    orgAccountRole: string;
    @deserializeAs(ROrgAccess)
    accessFrom: ROrgAccess;
    @deserializeAs(RMemberAccount)
    memberAccounts: Array<RMemberAccount> = [];
    @deserializeAs(ROrgUnit)
    orgUnits: Array<ROrgUnit> = [];
    @deserializeAs(RNode)
    nodes: Array<RNode> = [];

}
